import { useMemo } from 'react';

const avg = (arr) => {
  const valid = arr.filter(v => v !== null && v !== undefined && !isNaN(v));
  if (valid.length === 0) return 0;
  return valid.reduce((sum, v) => sum + v, 0) / valid.length;
};

const useMachineKPIs = (machineData) => {
  return useMemo(() => {
    if (!machineData || !machineData.slots) {
      return { avgSales: 0, avgMargin: 0, stockFill: 0, experimentsByStatus: {} };
    }

    const slots = machineData.slots;
    const filled = slots.filter(s => s.name && s.d_product_id);

    const experimentsByStatus = {};
    filled.forEach(s => {
      if (s.experiment && s.experiment.status !== 'rejected') {
        const status = s.experiment.status || 'pending';
        experimentsByStatus[status] = (experimentsByStatus[status] || 0) + 1;
      }
    });

    return {
      avgSales: avg(filled.map(s => s.productAvgSales)),
      avgMargin: avg(filled.map(s => s.productMargin)),
      stockFill: avg(filled.map(s => {
        const total = Math.max(s.total_stock_on_fillup || 0, 1);
        return (s.current_stock || 0) / total;
      })),
      experimentsByStatus,
    };
  }, [machineData]);
};

export default useMachineKPIs;
